export const tr = {
    categories: 'Kategoriler:',
    copied: 'Kopyalandı',
    'copy-error': 'Kopyalama sırasında hata oluştu',
    description: 'Yeniden pazarlama ve hedef kitle seçimi, anahtar sözcük grupları',
    'description-keywords': 'anahtar sözcük grupları',
    'description-retargetings': 'yeniden pazarlama ve hedef kitle seçimi',
    'description-screens': 'reklam alanları',
    'description-user-profile': 'kullanıcı profili',
    formats: 'Formatlar:',
    'go-to-edit-group': 'Grup düzenlemeye geç',
    'hide-full-value': 'Tüm koşulları gizle',
    'keywords-title': 'Anahtar sözcük grupları',
    'no-item': 'Belirtilmedi',
    'no-items': 'Belirtilmedi',
    operators: 'Operatörler:',
    regions: 'Coğrafi bölgeler:',
    'retargeting-title': 'Yeniden pazarlama ve hedef kitle seçimi',
    screens: 'Ekranlar:',
    'screens-title': 'Reklam alanları',
    'show-full-value': 'Tüm koşulları göster',
    title: 'Gösterim koşulları',
    'user-profile-title': 'Kullanıcı profili',
    'zone-categories': 'Ekran konumları:'
};
